import { BUSINESS, NAV_LINKS } from "@/data/site";

export const Footer = () => {
  return (
    <footer className="bg-[#0A1F3C] border-t border-[#1E3A5F] px-6 md:px-12 lg:px-24 py-16" data-testid="site-footer">
      <div className="grid md:grid-cols-3 gap-12">
        <div>
          <span className="inline-block bg-white px-3 py-2 mb-5">
            <img src="/assets/logo.png" alt="Apex Home Renovation LLC" className="h-14 w-auto" />
          </span>
          <p className="text-sm text-blue-100/70 leading-relaxed max-w-xs">
            Veteran-owned, family-oriented residential renovation company transforming houses into
            beautiful, functional homes across Central Virginia.
          </p>
          <p className="font-accent-script text-2xl text-[#D4AF37] mt-5">
            Reimagine. Renovate. Reach Your Apex.
          </p>
        </div>
        <div>
          <p className="text-[11px] uppercase tracking-[0.25em] text-[#D4AF37] mb-6">Navigate</p>
          <ul className="space-y-3">
            {NAV_LINKS.map((l) => (
              <li key={l.href}>
                <a href={l.href} data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                  className="text-sm text-blue-100/70 hover:text-[#D4AF37] transition-colors tracking-wide">
                  {l.label}
                </a>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <p className="text-[11px] uppercase tracking-[0.25em] text-[#D4AF37] mb-6">Contact</p>
          <p className="text-sm text-blue-200/70">Active Projects</p>
          <a href={BUSINESS.phoneActiveHref} className="text-white hover:text-[#D4AF37] text-lg font-serif">
            {BUSINESS.phoneActive}
          </a>
          <p className="text-sm text-blue-200/70 mt-4">Administration & Pending Projects</p>
          <a href={BUSINESS.phoneAdminHref} className="text-white hover:text-[#D4AF37] text-lg font-serif">
            {BUSINESS.phoneAdmin}
          </a>
          <p className="text-sm text-blue-200/70 mt-4">Email</p>
          <a href={`mailto:${BUSINESS.email}`} className="text-white hover:text-[#D4AF37] break-all">
            {BUSINESS.email}
          </a>
        </div>
      </div>
      <div className="border-t border-white/10 mt-12 pt-8 flex flex-col md:flex-row justify-between gap-3 text-xs text-blue-200/60 tracking-wide">
        <p>© {new Date().getFullYear()} Apex Home Renovation LLC. All rights reserved.</p>
        <p>Veteran-Owned • Family-Oriented • Est. {BUSINESS.established} • ApexHomeRenovation.com</p>
        <a href="/admin" data-testid="footer-admin-login-link" className="hover:text-[#D4AF37] transition-colors">
          Admin Login
        </a>
      </div>
    </footer>
  );
};
